module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("1. ")]), _c('span', {
    attrs: {
      "href": "#/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Limited Choices")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("2. ")]), _c('span', {
    attrs: {
      "href": "#/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("No Peace in the Home")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("3. ")]), _c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Keeping Up Appearances—Or Not")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Diminishing Choices")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Choices Have Consequences")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("To Be Healthy or Not to Be")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Time’s Up")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Choices")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("False Evidence Appearing Real")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Jubilee")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Forgiveness")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Keeping the Faith")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    staticClass: "item-number"
  }, [_vm._v("13. ")]), _c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Farewell, My Love")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abigailnabal",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Abigail & Nabal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/authorsnote",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Author’s Note")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/blacksteel",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Black Steel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/merryheartsinspirationalseries",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Merry Hearts Inspirational Series")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/heavencanbehell",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Heaven Can Be Hell")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/fireinthewater",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Fire in the Water")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/alsobypatgorgewalker",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Also by Pat G’Orge-Walker")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0